export default __webpack_public_path__ + "static/data-safety-m-fecd1bcbbb0f53a318954ca138f8cdcf.webp";